module.exports = "pegasus/assets/theme2/facebook-icon.png";